import React from "react";
import styled from "styled-components";
import colors from "../constatns/colors";
import useWindowDimensions from "../constatns/size";

import "../styles/home.css";
import GrTitle, { Title } from "../components/BgTitle";
import { Fade } from "react-reveal";

function About() {
    const { width, height } = useWindowDimensions();
  return (
      <div id="about">
          <GrTitle bgTitle={"WHAT AND WHY"} />
            <Title  title={"ABOUT"} />
    <Container width={width} height={height} >
        <Fade left>
            <InnerContainer width={width} height={height}>
                <MainHeading>
                    GearChain solves the last mile problem by connecting supply chain to blockchain.                </MainHeading>
                <SubHeading>
                    The supply chain market is worth $18.6 billion and is growing at a compound annual growth rate of 10.7%. Value growth is attributed to revamping of inventory management systems due to newly realized vulnerabilities. However, the cost for such revamping can run in excess of $100 million for large businesses; a proportionate figure for both small and midsize businesses.
                </SubHeading>
                <SubHeading>
                GearChain solves this problem by utilizing an efficient and affordable standardized solution built on a trustless protocol and a decentralized ecosystem across multiple blockchains. The blockchain is immutable, so one can be sure that the data shared is untampered.
                </SubHeading>

                <BtnContainer>
                    <Btn>
                        <a href="https://drive.google.com/file/d/1olvhJ5bIU8VxG4516queEvDLtdzRAhBE/view?usp=sharing"
                            style={{textDecoration: "none", color: colors.white}}
                        >
                            Whitepaper
                        </a>
                        {/* <HiArrowNarrowDown style={{marginLeft: 20, fontWeight: "bold"}}/> */}
                    </Btn>
                    {/* <VideoButton>
                        Our Eccosystem
                    </VideoButton> */}
                </BtnContainer>
            </InnerContainer>
        </Fade>
        <Fade right>
            <BlocksImg width={width} alt="Blocks" src={require("../assets/images/block.png")} />
        </Fade>
    </Container>
    </div>
  );
}

const Container = styled.div`
    display: flex;
    padding-left: ${({width})=> width * 0.1}px;
    padding-right: ${({width})=> width * 0.1}px;
    padding-bottom: 50px;
    justify-content: space-between;
    @media (max-width: 768px) {
        flex-direction: column-reverse;
    }
`

const InnerContainer = styled.div`
    display: flex;
    flex-direction: column;
    margin-top: ${({height})=> height * 0.05}px ;
    color: ${colors.white};
    width: ${({width})=> width/2.5}px;
    @media (max-width: 768px) {
        width: 100%;
    }
`

const MainHeading = styled.p`
    font-size: 30px;
    font-weight: bold;
    margin-bottom: 0px;
`

const SubHeading = styled.p`
    font-size: 16px;
`

const BtnContainer = styled.div`
    display: flex;
    margin-top: 20px;
`

const Btn = styled.button`
    border: 0px;
    display: flex;
    background-color: ${colors.btnPrimary};
    align-items: center;
    color: ${colors.white};
    padding: 10px 20px;
    border-radius: 5px;
`

const BlocksImg = styled.img`
    width: ${({width})=> width/3}px;
    height: ${({width})=> width/3}px;
    margin-top: 50px;
    @media (max-width: 768px) {
        width: ${({width})=> width/1.3}px;
        height: ${({width})=> width/1.3}px;
    }
`



export default About;
